import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { BlockChainCountdown, ErrorMessage, Loading } from '../../shared/layout';
import { withFirebase } from '../../shared/firebase';
import { getRouteParam, upgradeMdl } from '../../utils';

class PollVoteBase extends Component {

  static questionOptionsStyle = {
    width: 'initial',
    display: 'flex',
    justifyContent: 'start',
    flexDirection: 'column',
    alignItems: 'start',
  }

  static questionInError = {
    border: 'solid red 2px',
  }

  state = {
    loading: true,
    error: null,
    poll: null,
    answers: null,
    showErrors: false,
    voting: false,
    votingError: null,
  }

  getToken = () => getRouteParam(this.props, 'poll_token') && getRouteParam(this.props, 'poll_token').split('_')[1];
  getPollId = () => getRouteParam(this.props, 'poll_token') && getRouteParam(this.props, 'poll_token').split('_')[0];

  save = () => {
    const invalid = this.state.answers.some(answer => answer === null || answer === undefined);

    if (invalid) {
      this.setState({ showErrors: true })
      return;
    }

    this.setState({ voting: true, votingError: null })

    this.props.firebase.vote(this.getPollId(), this.getToken(), this.state.answers)
      .then(data => {
        const tokenAndId = this.props.location && this.props.location.pathname ? this.props.location.pathname.split('vote/')[1]: null;
        const txID = data && data.meta && data.meta.txID;
        const net = this.state.poll && this.state.poll.net ? this.state.poll.net : 'TEST';
        const routeOptions = { tokenAndId, net };

        this.setState({ voting: false }, () => this.props.history.push(txID ? `/?tx=${txID}` : '/', routeOptions));
      })
      .catch(err => {
        console.log(err);
        this.setState({ voting: false, votingError: err ? err.message : 'GENERIC_ERROR' });
      });
  }

  onAnswerChange = (questionIndex, answerIndex) => {
    const answers = [...this.state.answers];
    answers[questionIndex] = answerIndex;
    this.setState({ answers }, () => console.log(this.state.answers));
  }

  componentDidMount() {
    upgradeMdl();

    const pollId = this.getPollId();
    const token = this.getToken();

    this.props.firebase.getPoll(pollId)
      .then(poll => {
        const answers = (poll.questions || []).map(() => null);
        this.setState({ poll, loading: false, error: null, answers }, upgradeMdl);
      })
      .then(() => this.props.firebase.getPollToken(pollId, token))
      .then(result => {
        if (!result.valid) {
          throw Error(`Token: ${token} is no longer active, it has been already used!`)
        }
      })
      .catch(err => {
        console.error(err);
        const isTokenError = err && err.message.indexOf(token) !== -1;

        this.setState({ loading: false, error: (isTokenError && err) ? err.message : `We are sorry, there is no poll with id: ${pollId}` });
      })
  };

  render() {
    const { loading, poll, error, answers, showErrors, voting, votingError } = this.state;

    return loading || voting ? <div className="loading-page-content">{ loading ? <Loading /> : <BlockChainCountdown /> }</div> :
      error ? <div className="error-page-content"><ErrorMessage message={error} /></div> : (
      <div>
        <div className="mdl-grid">
          <div className="mdl-card mdl-shadow--2dp mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--12-col-desktop" style={{ minHeight: 100 }}>
            <div className="mdl-card__title mdl-color--primary-dark mdl-color-text--white">
              <h2 className="mdl-card__title-text">{poll.name}</h2>
            </div>

            <div className="mdl-card__supporting-text mdl-color-text--grey-600" style={{width: 'initial'}}>
              <p>{poll.description}</p>
            </div>
          </div>

          {
            (poll.questions || []).map((question, questionIndex) => (
              <div
                key={`${question.name}_${questionIndex}`}
                className="mdl-card mdl-shadow--2dp mdl-cell mdl-cell--6-col mdl-cell--12-col-tablet mdl-cell--6-col-desktop"
                style={showErrors && (answers[questionIndex] === null || answers[questionIndex] === undefined) ? PollVoteBase.questionInError : null}
              >
                <div className="mdl-card__title mdl-color--primary mdl-color-text--white">
                  <h2 className="mdl-card__title-text">{questionIndex + 1}: {question.name}</h2>
                </div>

                <fieldset id={`question_${questionIndex}`}>
                  <div
                    className="mdl-card__supporting-text mdl-color-text--grey-600"
                    style={PollVoteBase.questionOptionsStyle}>
                    {
                      (question.answers || []).map((answer, answerIndex) => (
                        <label key={`${question.name}_${questionIndex}_${answer}`} className="mdl-radio mdl-js-radio mdl-js-ripple-effect" style={{marginTop: '6px', marginBottom: '6px'}} htmlFor={`answer_${questionIndex}_${answerIndex}`}>
                          <input
                            type="radio"
                            id={`answer_${questionIndex}_${answerIndex}`}
                            className="mdl-radio__button"
                            name={`question_${questionIndex}`}
                            value={answerIndex}
                            onClick={() => this.onAnswerChange(questionIndex, answerIndex)}
                          />
                          <span className="mdl-radio__label">{answer}</span>
                        </label>
                      ))
                    }
                  </div>
                </fieldset>
              </div>
            ))
          }

        </div>

        {
          votingError ?
          <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '120px' }}>
            <ErrorMessage overrideStyles={{minWidth: '480px', padding: '0px'}} message={votingError} />
          </div> : null
        }

        <div>
          <button disabled={voting} onClick={this.save} className="mdl-button mdl-js-button mdl-button--raised mdl-button--accent" style={{marginBottom: '56px' }}>
            Vote
          </button>
        </div>
      </div>
    )
  }
};

export const PollVote = compose(withRouter, withFirebase)(PollVoteBase);
